export default {
  WEBSITE_SETTINGS: 'website-settings',
  MAIN_MENU: 'main-menu',
  EDITOR_HEADER: 'editor-header',
  PAGE_SETTINGS: 'page-settings',
  PREMIUM_ICON_LIBRARY: 'premium-icon-library',
  SUBSCRIPTION_EXPIRED_DIALOG: 'subscription-expired-dialog',
  ADD_PAGE_PLUS_BUTTON: 'add-page-plus-button',
  ADD_FOLDER_PLUS_BUTTON: 'add-folder-plus-button',
  ADD_PAGE: 'add-page',
  AI_PAGE: 'ai-page',
  PUBLISH_INTERRUPTION: 'publish-interruption',
  DIALOG_BACKGROUND: 'dialog-background',
  SUBMIT_BUTTON: 'submit-button',
  YOLA_HEADER: 'yola-header',
};
